defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/ThemeDesignOptions',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    var optionsListItems = ['colorThemes']; // 'backgrounds', 'badgeBackgrounds', 'badges' options is removed for now but the backend have the support
    var checkMarkIcon = function () {
      return m('.play-together__personalization-option-icon-wrapper',
        m('svg.play-together__personalization-option-icon', m('use', {
          href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#checkmark'
        }))
      );
    };

    var ThemeDesignOptions = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.dictionary = controller.rootDictionary.get.bind({ prefix: 'Shared/ThemeDesignOptions/' });
        if (!this.clubTheme().colorTheme()) {
          this.clubTheme().colorTheme(this.personalizationOptions().colorThemes[0]);
        }

        const optionsLabelsDictionaryMap = {
          badges: this.dictionary('BadgeLabel'),
          badgeBackgrounds: this.dictionary('BadgeBackgroundLabel'),
          colorThemes: this.dictionary('ColorLabel'),
          backgrounds: this.dictionary('PatternBackgroundLabel')
        };

        this.personalizationOptionsItem = (option) => {
          return m('.play-together__personalization-options-item', [
            m('.play-together__personalization-options-item-label', optionsLabelsDictionaryMap[option]),
            m('.play-together__personalization-options-item-wrapper', this.personalizationOptions()[option].map((optionItem) => {
              // background color options
              if (option === 'colorThemes') {
                var isSelectedColor = optionItem.id === this.clubTheme().colorTheme().id;
                return m('.play-together__personalization-option', {
                  class: isSelectedColor ? 'play-together__personalization-option--selected' : '',
                  onclick: () => {
                    this.clubTheme().colorTheme(optionItem);
                  }
                }, [
                  m('.play-together__personalization-option-panel', {
                    style: 'background-color:' + optionItem.code,
                  }),
                  isSelectedColor ? checkMarkIcon() : null
                ]);
              }

              // background image patterns options
              if (option === 'backgrounds') {
                if (!this.clubTheme().background()) {
                  this.clubTheme().background(this.personalizationOptions().backgrounds[0]);
                }
                var isBackgroundSelected = optionItem.id === this.clubTheme().background().id;
                return m('.play-together__personalization-option.with-bottom-gradient', {
                  class: isBackgroundSelected ? 'play-together__personalization-option--selected' : '',
                  onclick: () => {
                    this.clubTheme().background(optionItem);
                  }
                }, m('.play-together__personalization-option-panel', {
                  style: 'background-color:' + this.clubTheme().colorTheme().code
                }, [
                  isBackgroundSelected ? checkMarkIcon() : null,
                  m('.play-together__personalization-background-option', { style: 'background-image: url(' + optionItem.url + ')' })
                ]));
              }
            }))
          ]);
        };
      },
      view: function (controller) {
        return m('.play-together__create-club-flow-step', [
          m('.play-together__personalization-options-list', [
            controller.personalizationOptions() ? optionsListItems.map(function (listItem) {
              return controller.personalizationOptionsItem(listItem);
            }) : null
          ])
        ]);
      }
    };

    // Public functions:
    return ThemeDesignOptions;
  });
